exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".flexRow[data-v-9e55d97e]{align-items:flex-end;justify-content:center}.blockGraph[data-v-9e55d97e]{margin:2rem 1rem}.graph[data-v-9e55d97e]{margin-top:2rem}.flexRow.blockRow[data-v-9e55d97e]{padding:.25rem}.stats[data-v-9e55d97e]{font-size:.75rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-9e55d97e&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/components/BlockGraph.vue
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-9e55d97e&scoped=true!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/components/BlockGraph.vue
// module chunks = 0